import { useEffect, useMemo } from "react";

import { atom, useAtom, useSetAtom } from "jotai";

const pageTitleAtom = atom("Northbeam");

export const usePageTitle = () => {
  const [_pageTitle, setPageTitle] = useAtom(pageTitleAtom);
  const pageTitle = useMemo(() => {
    let title = "Northbeam";
    if (_pageTitle && _pageTitle !== "Northbeam") {
      title = `${_pageTitle} | Northbeam`;
    }
    document.title = title;
    return _pageTitle;
  }, [_pageTitle]);

  return [pageTitle, setPageTitle] as const;
};

export const useSetPageTitle = (title: string) => {
  const setPageTitle = useSetAtom(pageTitleAtom);

  useEffect(() => {
    setPageTitle(title);
  }, [setPageTitle, title]);
};
